import { loadStripe, Stripe } from '@stripe/stripe-js'

const publishableKey = process.env.NODE_ENV === 'production'
  ? process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
  : process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_TEST

let stripePromise: Promise<Stripe | null> | null = null
const checkoutStripePromises = new Map<'es' | 'en', Promise<Stripe | null>>()

// Scoped to subscription Checkout: Tax ID Element is a Stripe public preview.
// Do not enable its beta on the payment-method editor or Connect instances.
export const getCheckoutStripe = (locale: 'es' | 'en'): Promise<Stripe | null> => {
  if (!publishableKey) throw new Error('Missing NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')
  if (!checkoutStripePromises.has(locale)) {
    checkoutStripePromises.set(locale, loadStripe(publishableKey, { locale, betas: ['custom_checkout_tax_id_1'] }))
  }
  return checkoutStripePromises.get(locale)!
}

export const getStripe = (): Promise<Stripe | null> => {
  if (!publishableKey) {
    throw new Error('Missing NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')
  }
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey)
  }
  return stripePromise
}

// Cache of stripe instances scoped to each connected account (for delivery payments).
const stripeConnectCache = new Map<string, Promise<Stripe | null>>()

export const getStripeForAccount = (connectAccountId: string): Promise<Stripe | null> => {
  if (!publishableKey) {
    throw new Error('Missing NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')
  }
  if (!stripeConnectCache.has(connectAccountId)) {
    stripeConnectCache.set(
      connectAccountId,
      loadStripe(publishableKey, { stripeAccount: connectAccountId })
    )
  }
  return stripeConnectCache.get(connectAccountId)!
}
